import React, { FC } from 'react'
import { StyledUserSettingsLink } from './UserSettingsLink.styled'
import { DisplayProperty, TextTransformProperty } from 'csstype'

export interface UserSettingsLinkProps {
    color?: string
    fontWeight?: number
    display?: DisplayProperty
    disabled?: boolean
    marginBottom?: number
    margin?: number | string
    width?: string
    underline?: boolean
    onClick: () => void
    textTransform?: TextTransformProperty
}

export const UserSettingsLink: FC<UserSettingsLinkProps> = (props) => {
    return (
        <StyledUserSettingsLink
            tabIndex={props.disabled ? -1 : 0}
            {...props}
            onKeyDown={(event) => {
                if (props.disabled) return

                if (event.key === 'Enter') {
                    props.onClick()
                }
            }}
        >
            {props.children}
        </StyledUserSettingsLink>
    )
}
